import styled from 'styled-components'

export const ProfilePictureContainer = styled.div`
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const PROFILE_PICTURE_SIZE_PERCENTAGE = 90
export const ProfilePictureImage = styled.img`
  width: ${PROFILE_PICTURE_SIZE_PERCENTAGE}%;
  height: ${PROFILE_PICTURE_SIZE_PERCENTAGE}%;
  border-radius: 50%;
  object-fit: cover;
`

export const CircleScribble = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`

export const VipIndicator = styled.img`
  position: absolute;
  right: 0;
  bottom: 50%;
  transform: translate(40%, 10%);
  height: calc(200% / 3);
`
